<template>
  <div class="home-page">
    <!-- 顶部 Logo 区域 -->
    <div class="header-section">
      <!-- <div class="logo-wrapper">
        <div class="logo-icon">
          <div class="star star-1"></div>
          <div class="star star-2"></div>
          <div class="star star-3"></div>
        </div>
      </div> -->
      <h1 class="app-title">Nano 图片编辑</h1>
      <p class="app-subtitle">智能图像编辑新体验</p>
      <p class="app-description">
        革命性的 AI 图像编辑技术，用自然语言轻松编辑图片，保持主体一致性，让创意无限可能。
      </p>
      <button class="start-btn" @click="startEdit">
        <svg class="btn-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 19L19 12L22 15L15 22L12 19Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M18 13L16.5 5.5L2 2L5.5 16.5L13 18L18 13Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        开始 AI 编辑图片
      </button>
    </div>

    <!-- 工具列表区域 -->
    <div class="tools-section">
      <h2 class="section-title">AI 工具箱</h2>
      <p class="section-subtitle">选择你需要的 AI 工具</p>

      <div class="tools-grid">
        <!-- gpt-2-image -->
        <div class="tool-card" @click="selectTool('gpt-image-2')">
          <div class="tool-image">
            <img src="/images/tools/MaskStreaming.jpg" alt="gpt-image-2" />
          </div>
          <div class="tool-info">
            <h3 class="tool-name">gpt-image-2</h3>
            <p class="tool-desc">最强图像模型gpt-image-2抢先体验</p>
          </div>
        </div>

        <!-- 3D 手办 -->
        <div class="tool-card" @click="selectTool('3d-figure')">
          <div class="tool-image">
            <img src="/images/tools/3d-figure.png" alt="3D 手办" />
          </div>
          <div class="tool-info">
            <h3 class="tool-name">3D 手办</h3>
            <p class="tool-desc">将照片转化 3D 手办模型</p>
          </div>
        </div>

        <!-- AI 修图 P 图 -->
        <div class="tool-card" @click="selectTool('ai-edit')">
          <div class="tool-image">
            <img src="/images/tools/ai-edit.jpg" alt="AI修图P图" />
          </div>
          <div class="tool-info">
            <h3 class="tool-name">AI 修图 P 图</h3>
            <p class="tool-desc">告别 PS 软件，AI 一句话完成修图</p>
          </div>
        </div>

        <!-- 商品展示 -->
        <div class="tool-card" @click="selectTool('product-display')">
          <div class="tool-image">
            <img src="/images/tools/product-display.png" alt="商品展示" />
          </div>
          <div class="tool-info">
            <h3 class="tool-name">商品展示</h3>
            <p class="tool-desc">智能设计商品展示图</p>
          </div>
        </div>

        <!-- 换服装 -->
        <div class="tool-card" @click="selectTool('change-clothes')">
          <div class="tool-image">
            <img src="/images/tools/change-clothes.png" alt="换服装" />
          </div>
          <div class="tool-info">
            <h3 class="tool-name">换服装</h3>
            <p class="tool-desc">智能替换自定义服装</p>
          </div>
        </div>

        <!-- 像素级拆解 -->
        <div class="tool-card" @click="selectTool('pixel-breakdown')">
          <div class="tool-image">
            <img src="/images/tools/pixel-breakdown.png" alt="像素级拆解" />
          </div>
          <div class="tool-info">
            <h3 class="tool-name">像素级拆解</h3>
            <p class="tool-desc">一键像素级拆解角色</p>
          </div>
        </div>

        <!-- 换发型 -->
        <div class="tool-card" @click="selectTool('change-hair')">
          <div class="tool-image">
            <img src="/images/tools/change-hair.png" alt="换发型" />
          </div>
          <div class="tool-info">
            <h3 class="tool-name">换发型</h3>
            <p class="tool-desc">智能替换自定义发型</p>
          </div>
        </div>

        <!-- 爱豆合照 -->
        <div class="tool-card" @click="selectTool('group-photo')">
          <div class="tool-image">
            <img src="/images/tools/group-photo.jpg" alt="爱豆合照" />
          </div>
          <div class="tool-info">
            <h3 class="tool-name">爱豆合照</h3>
            <p class="tool-desc">和你喜欢的爱豆一起合照</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 功能介绍区域 -->
    <div class="features-section">
      <h2 class="section-title">图片编辑如此简单！</h2>
      <p class="section-subtitle">强大的 AI 技术，让图像编辑变得简单</p>

      <div class="feature-list">
        <div class="feature-item">
          <div class="feature-icon palette">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
              <circle cx="12" cy="8" r="2" fill="currentColor"/>
              <circle cx="8" cy="14" r="2" fill="currentColor"/>
              <circle cx="16" cy="14" r="2" fill="currentColor"/>
            </svg>
          </div>
          <h3 class="feature-title">智能编辑</h3>
          <p class="feature-desc">AI 驱动的图像编辑，精准识别主体</p>
        </div>

        <div class="feature-item">
          <div class="feature-icon chat">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21 15C21 15.5304 20.7893 16.0391 20.4142 16.4142C20.0391 16.7893 19.5304 17 19 17H7L3 21V7C3 6.46957 3.21071 5.96086 3.58579 5.58579C3.96086 5.21071 4.46957 5 5 5H19C19.5304 5 20.0391 5.21071 20.4142 5.58579C20.7893 5.96086 21 6.46957 21 7V15Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <h3 class="feature-title">自然语言</h3>
          <p class="feature-desc">用文字描述你的想法，AI 帮你实现</p>
        </div>

        <div class="feature-item">
          <div class="feature-icon lightning">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13 2L3 14H12L11 22L21 10H12L13 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <h3 class="feature-title">极速生成</h3>
          <p class="feature-desc">秒级生成高质量图片，无需等待</p>
        </div>

        <div class="feature-item">
          <div class="feature-icon target">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
              <circle cx="12" cy="12" r="6" stroke="currentColor" stroke-width="2"/>
              <circle cx="12" cy="12" r="2" fill="currentColor"/>
            </svg>
          </div>
          <h3 class="feature-title">主体一致</h3>
          <p class="feature-desc">保持人物特征，编辑更自然</p>
        </div>
      </div>
    </div>

    <!-- 底部行动区域 -->
    <div class="cta-section">
      <h2 class="cta-title">开始你的 AI 创作之旅</h2>
      <p class="cta-desc">上传图片，用文字描述你的想法，让 AI 为你创造惊喜</p>
      <div class="cta-buttons">
        <button class="cta-btn primary" @click="startEdit">
          <svg class="btn-small-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 20H9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12 20H15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12 20V13" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          开始编辑
        </button>
        <button class="cta-btn secondary" @click="goToTools">
          <svg class="btn-small-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="2"/>
            <path d="M19.4 15C20.1 14.3 20.5 13.2 20.5 12C20.5 10.8 20.1 9.7 19.4 9" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            <path d="M15 19.4C15.7 20.1 16.8 20.5 18 20.5C19.2 20.5 20.3 20.1 21 19.4" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            <path d="M4.6 9C3.9 9.7 3.5 10.8 3.5 12C3.5 13.2 3.9 14.3 4.6 15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            <path d="M9 4.6C8.3 3.9 7.2 3.5 6 3.5C4.8 3.5 3.7 3.9 3 4.6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            <path d="M15 4.6C15.7 3.9 16.8 3.5 18 3.5C19.2 3.5 20.3 3.9 21 4.6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            <path d="M4.6 15C3.9 15.7 3.5 16.8 3.5 18C3.5 19.2 3.9 20.3 4.6 21" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            <path d="M9 19.4C8.3 20.1 7.2 20.5 6 20.5C4.8 20.5 3.7 20.1 3 19.4" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
          更多工具
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { getUrlParam } from '@/utils/wechatAuth';

export default {
  name: 'HomePage',
  mounted() {
    // 检查 URL 中是否有 agent 参数，如果有则保存到 localStorage
    const agentId = getUrlParam('agent');
    if (agentId) {
      localStorage.setItem('agentId', agentId);
      console.log('保存代理ID:', agentId);
    }
  },
  methods: {
    startEdit() {
      this.$router.push('/image-edit');
    },
    goToTools() {
      this.$router.push('/tools');
    },
    selectTool(toolId) {
      console.log('选择工具', toolId);
      // 跳转到示例广场，并传递工具类型参数
      this.$router.push({
        path: '/example-square',
        query: { toolType: toolId }
      });
    }
  }
};
</script>

<style scoped>
.home-page {
  min-height: 100vh;
  background: linear-gradient(180deg, #fff5eb 0%, #faf8f5 50%, #fff 100%);
  padding: 40px 20px 80px;
}

.header-section {
  text-align: center;
  padding: 20px 0 40px;
}

.logo-wrapper {
  margin-bottom: 20px;
}

.logo-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #1a1a2e 0%, #2d2d44 100%);
  border-radius: 20px;
  margin: 0 auto;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

.star {
  position: absolute;
  width: 20px;
  height: 20px;
}

.star-1 {
  top: 15px;
  left: 15px;
  color: #ffd700;
}

.star-2 {
  top: 45px;
  right: 15px;
  color: #ff69b4;
}

.star-3 {
  bottom: 15px;
  left: 25px;
  color: #87ceeb;
}

.star svg {
  width: 100%;
  height: 100%;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
}

.app-title {
  font-size: 28px;
  font-weight: bold;
  background: linear-gradient(135deg, #ff9500 0%, #ff6b9d 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 8px;
}

.app-subtitle {
  font-size: 16px;
  color: #666;
  margin-bottom: 12px;
}

.app-description {
  font-size: 13px;
  color: #999;
  line-height: 1.6;
  padding: 0 20px;
  margin-bottom: 30px;
}

.start-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #ff9500 0%, #ff6b9d 100%);
  color: white;
  border: none;
  padding: 14px 40px;
  border-radius: 25px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  box-shadow: 0 4px 15px rgba(255, 149, 0, 0.3);
  transition: all 0.3s ease;
}

.start-btn:active {
  transform: scale(0.98);
}

.btn-icon {
  width: 20px;
  height: 20px;
  margin-right: 8px;
  stroke: white;
}

.features-section {
  background: white;
  border-radius: 16px;
  padding: 30px 20px;
  margin-bottom: 30px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
}

.section-title {
  font-size: 22px;
  font-weight: bold;
  text-align: center;
  background: linear-gradient(135deg, #ff9500 0%, #ff6b9d 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 8px;
}

.section-subtitle {
  font-size: 13px;
  color: #999;
  text-align: center;
  margin-bottom: 30px;
}

.feature-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.feature-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  background: #fafafa;
  border-radius: 12px;
}

.feature-icon {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
}

.feature-icon svg {
  width: 28px;
  height: 28px;
}

.feature-icon.palette {
  color: #ff9500;
}

.feature-icon.chat {
  color: #4a90d9;
}

.feature-icon.lightning {
  color: #ffd700;
}

.feature-icon.target {
  color: #ff6b9d;
}

.feature-title {
  font-size: 16px;
  font-weight: 500;
  color: #333;
  margin-bottom: 6px;
}

.feature-desc {
  font-size: 12px;
  color: #999;
  text-align: center;
}

.cta-section {
  background: linear-gradient(135deg, #ff9500 0%, #ff6b9d 100%);
  border-radius: 16px;
  padding: 30px 20px;
  text-align: center;
  color: white;
}

.cta-title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 8px;
}

.cta-desc {
  font-size: 13px;
  opacity: 0.9;
  line-height: 1.6;
  margin-bottom: 20px;
}

.cta-buttons {
  display: flex;
  gap: 10px;
  justify-content: center;
}

.cta-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border: none;
  transition: all 0.2s ease;
}

.cta-btn.primary {
  background: white;
  color: #ff9500;
}

.cta-btn.secondary {
  background: rgba(255, 255, 255, 0.2);
  color: white;
}

.cta-btn:active {
  transform: scale(0.98);
}

.btn-small-icon {
  width: 18px;
  height: 18px;
  margin-right: 6px;
  stroke: currentColor;
}

/* 工具网格样式 */
.tools-section {
  background: white;
  border-radius: 16px;
  padding: 30px 20px;
  margin-bottom: 30px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
}

.tools-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.tool-card {
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid #f0f0f0;
}

.tool-card:active {
  transform: scale(0.98);
}

.tool-image {
  width: 100%;
  height: 120px;
  overflow: hidden;
  background: #f5f5f5;
}

.tool-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.tool-image.banana {
  background: #ffeb3b;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
}

.banana-logo {
  width: 60px;
  height: 40px;
  margin-bottom: 6px;
}

.banana-logo svg {
  width: 100%;
  height: 100%;
}

.tool-brand {
  font-size: 18px;
  font-weight: bold;
  color: #000;
}

.tool-brand-sub {
  font-size: 10px;
  color: #333;
  margin-top: 2px;
}

.tool-info {
  padding: 12px;
}

.tool-name {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 4px;
}

.tool-desc {
  font-size: 11px;
  color: #999;
  line-height: 1.4;
}
</style>
